/**
 * Calculate random number for percent number on machines
 * @param {Integer} resultIndex Index from current result
 * @return {Integer}  Random Integer number between min and max calculated in randomNumber()
 */
export function randomPercentNumberByIndex(resultIndex) {
  const min = 100 - 5 - resultIndex * 3
  const max = 100 - 3 - resultIndex * 3
  return randomNumber(min, max)
}

/**
 * Genereate random Integer number
 * @param {Integer} min Min number for random function
 * @param {Integer} max Max number for random function
 * @return {Integer} Random Integer number between min and max
 */
export function randomNumber(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}
